import {Button, Modal, ModalProps, NumberInput, Select, Stack} from "@mantine/core";
import {useState} from "react";
import {FtpSynchronizationAPI} from "../../api/ftp/synchronization/FtpSynchronizationAPI";
import {showNotification} from "@mantine/notifications";

export type SynchronizationModalProps = Omit<ModalProps, "children">;

export const SynchronizationModal = (props: SynchronizationModalProps) => {
  const [isLoading, setLoading] = useState<boolean>(false);
  const [month, setMonth] = useState<number>(new Date().getMonth()); // Should be +1 (zero based to 1 based) and -1 (previous month)
  const [year, setYear] = useState<number>(new Date().getFullYear());

  const onPress = () => {
  setLoading(true);

  FtpSynchronizationAPI.forceSync({ month, year })
    .then(() => {
      props.onClose?.();

      showNotification({
        title: "Synchronizacja uruchomiona",
        message:
          "Synchronizacja została przyjęta do przetwarzania. Dane pojawią się w zakładce Raporty po zakończeniu procesu.",
      });
    })
    .catch(() => {
      showNotification({
        title: "Błąd uruchamiania synchronizacji",
        message:
          "Nie udało się uruchomić synchronizacji. Sprawdź połączenie lub skontaktuj się z administratorem.",
      });
    })
    .finally(() => {
      setLoading(false);
    });
};

  return (
    <Modal
      centered
      size="sm"
      transitionProps={{transition: 'pop'}}
      overlayProps={{backgroundOpacity: 0.55, blur: 3}}
      title="Wymuś synchronizację"
      {...props}
    >
      <Stack gap="sm">
        <Select
          required
          label="Miesiąc"
          value={month.toString()}
          onChange={(value) => setMonth(parseInt(value))}
          data={[
            {value: "1", label: "Styczeń"},
            {value: "2", label: "Luty"},
            {value: "3", label: "Marzec"},
            {value: "4", label: "Kwiecień"},
            {value: "5", label: "Maj"},
            {value: "6", label: "Czerwiec"},
            {value: "7", label: "Lipiec"},
            {value: "8", label: "Sierpień"},
            {value: "9", label: "Wrzesień"},
            {value: "10", label: "Październik"},
            {value: "11", label: "Listopad"},
            {value: "12", label: "Grudzień"}
          ]}
        />

        <NumberInput
          required
          value={year}
          description=""
          onValueChange={({floatValue}) => setYear(floatValue)}
          label="Rok"
        />

        <Button fullWidth onClick={onPress} loading={isLoading} mt="md" disabled={isLoading}>
          Synchronizuj
        </Button>
      </Stack>
    </Modal>
  );
}